import { Controller } from "stimulus";

// Toggles visibility of MAPD/PDP label fields based on display mode selection
export default class extends Controller {
  static targets = ["combined", "split"];

  connect() {
    this.update();
  }

  update() {
    const mode = this.element.querySelector(
      'input[name="portal[mapd_pdp_display_mode]"]:checked',
    )?.value;

    this.combinedTargets.forEach(el => el.classList.toggle("hidden", mode !== "combined"));
    this.splitTargets.forEach(el => el.classList.toggle("hidden", mode !== "split"));
  }
}
